export const bodyTypes = [
  'Hatchback',
  'Saloon',
  'Estate',
  'SUV',
  'Coupe',
  'Convertible',
  'MPV',
  'Pickup',
  'Van',
  'Other',
];
